module.exports = __webpack_public_path__ + "img/wave-4.2c879212.svg";